var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 573.042,
    height: 465.141,
    viewBox: "0 0 573.042 465.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14564",
    "data-name": "Group 14564",
    transform: "translate(-1079.958 -5937.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14156",
    "data-name": "Group 14156",
    transform: "translate(1217.356 6092.444) rotate(-90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2566",
    "data-name": "Ellipse 2566",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2643",
    "data-name": "Ellipse 2643",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2567",
    "data-name": "Ellipse 2567",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2629",
    "data-name": "Ellipse 2629",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2568",
    "data-name": "Ellipse 2568",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2644",
    "data-name": "Ellipse 2644",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2569",
    "data-name": "Ellipse 2569",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2630",
    "data-name": "Ellipse 2630",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2570",
    "data-name": "Ellipse 2570",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2670",
    "data-name": "Ellipse 2670",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2571",
    "data-name": "Ellipse 2571",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2672",
    "data-name": "Ellipse 2672",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2572",
    "data-name": "Ellipse 2572",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2573",
    "data-name": "Ellipse 2573",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2561",
    "data-name": "Ellipse 2561",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2574",
    "data-name": "Ellipse 2574",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2575",
    "data-name": "Ellipse 2575",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2641",
    "data-name": "Ellipse 2641",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2576",
    "data-name": "Ellipse 2576",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2631",
    "data-name": "Ellipse 2631",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2577",
    "data-name": "Ellipse 2577",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2642",
    "data-name": "Ellipse 2642",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2578",
    "data-name": "Ellipse 2578",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2632",
    "data-name": "Ellipse 2632",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2579",
    "data-name": "Ellipse 2579",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2674",
    "data-name": "Ellipse 2674",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2580",
    "data-name": "Ellipse 2580",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2676",
    "data-name": "Ellipse 2676",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2581",
    "data-name": "Ellipse 2581",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2582",
    "data-name": "Ellipse 2582",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2562",
    "data-name": "Ellipse 2562",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2583",
    "data-name": "Ellipse 2583",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2584",
    "data-name": "Ellipse 2584",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2633",
    "data-name": "Ellipse 2633",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2585",
    "data-name": "Ellipse 2585",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2623",
    "data-name": "Ellipse 2623",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2586",
    "data-name": "Ellipse 2586",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2634",
    "data-name": "Ellipse 2634",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2587",
    "data-name": "Ellipse 2587",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2624",
    "data-name": "Ellipse 2624",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2588",
    "data-name": "Ellipse 2588",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2678",
    "data-name": "Ellipse 2678",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2589",
    "data-name": "Ellipse 2589",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2680",
    "data-name": "Ellipse 2680",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2590",
    "data-name": "Ellipse 2590",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2591",
    "data-name": "Ellipse 2591",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2563",
    "data-name": "Ellipse 2563",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2592",
    "data-name": "Ellipse 2592",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2593",
    "data-name": "Ellipse 2593",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2635",
    "data-name": "Ellipse 2635",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2594",
    "data-name": "Ellipse 2594",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2625",
    "data-name": "Ellipse 2625",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2595",
    "data-name": "Ellipse 2595",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2636",
    "data-name": "Ellipse 2636",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2596",
    "data-name": "Ellipse 2596",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2626",
    "data-name": "Ellipse 2626",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2597",
    "data-name": "Ellipse 2597",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2682",
    "data-name": "Ellipse 2682",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2598",
    "data-name": "Ellipse 2598",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2684",
    "data-name": "Ellipse 2684",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2599",
    "data-name": "Ellipse 2599",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2600",
    "data-name": "Ellipse 2600",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2564",
    "data-name": "Ellipse 2564",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2601",
    "data-name": "Ellipse 2601",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2602",
    "data-name": "Ellipse 2602",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2637",
    "data-name": "Ellipse 2637",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2603",
    "data-name": "Ellipse 2603",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2621",
    "data-name": "Ellipse 2621",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2604",
    "data-name": "Ellipse 2604",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2638",
    "data-name": "Ellipse 2638",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2605",
    "data-name": "Ellipse 2605",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2627",
    "data-name": "Ellipse 2627",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2606",
    "data-name": "Ellipse 2606",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2686",
    "data-name": "Ellipse 2686",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2607",
    "data-name": "Ellipse 2607",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2688",
    "data-name": "Ellipse 2688",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2608",
    "data-name": "Ellipse 2608",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2609",
    "data-name": "Ellipse 2609",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2565",
    "data-name": "Ellipse 2565",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2610",
    "data-name": "Ellipse 2610",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2611",
    "data-name": "Ellipse 2611",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2639",
    "data-name": "Ellipse 2639",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2556",
    "data-name": "Ellipse 2556",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2653",
    "data-name": "Ellipse 2653",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2612",
    "data-name": "Ellipse 2612",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2622",
    "data-name": "Ellipse 2622",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2613",
    "data-name": "Ellipse 2613",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2640",
    "data-name": "Ellipse 2640",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2557",
    "data-name": "Ellipse 2557",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2654",
    "data-name": "Ellipse 2654",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2614",
    "data-name": "Ellipse 2614",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2628",
    "data-name": "Ellipse 2628",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2615",
    "data-name": "Ellipse 2615",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2690",
    "data-name": "Ellipse 2690",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2558",
    "data-name": "Ellipse 2558",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2691",
    "data-name": "Ellipse 2691",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2616",
    "data-name": "Ellipse 2616",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2692",
    "data-name": "Ellipse 2692",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2617",
    "data-name": "Ellipse 2617",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2559",
    "data-name": "Ellipse 2559",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2618",
    "data-name": "Ellipse 2618",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2619",
    "data-name": "Ellipse 2619",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2560",
    "data-name": "Ellipse 2560",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2620",
    "data-name": "Ellipse 2620",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 114.935)",
    fill: "#121917"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14484",
    "data-name": "Group 14484",
    transform: "translate(1453.506 6370.829) rotate(-90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2566-2",
    "data-name": "Ellipse 2566",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2643-2",
    "data-name": "Ellipse 2643",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2567-2",
    "data-name": "Ellipse 2567",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2629-2",
    "data-name": "Ellipse 2629",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2568-2",
    "data-name": "Ellipse 2568",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2644-2",
    "data-name": "Ellipse 2644",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2569-2",
    "data-name": "Ellipse 2569",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2630-2",
    "data-name": "Ellipse 2630",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2570-2",
    "data-name": "Ellipse 2570",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2670-2",
    "data-name": "Ellipse 2670",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2571-2",
    "data-name": "Ellipse 2571",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2672-2",
    "data-name": "Ellipse 2672",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2572-2",
    "data-name": "Ellipse 2572",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2573-2",
    "data-name": "Ellipse 2573",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2561-2",
    "data-name": "Ellipse 2561",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 8.967)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2574-2",
    "data-name": "Ellipse 2574",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 66.842)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2575-2",
    "data-name": "Ellipse 2575",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2641-2",
    "data-name": "Ellipse 2641",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2576-2",
    "data-name": "Ellipse 2576",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2631-2",
    "data-name": "Ellipse 2631",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2577-2",
    "data-name": "Ellipse 2577",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2642-2",
    "data-name": "Ellipse 2642",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2578-2",
    "data-name": "Ellipse 2578",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2632-2",
    "data-name": "Ellipse 2632",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2579-2",
    "data-name": "Ellipse 2579",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2674-2",
    "data-name": "Ellipse 2674",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2580-2",
    "data-name": "Ellipse 2580",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2676-2",
    "data-name": "Ellipse 2676",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2581-2",
    "data-name": "Ellipse 2581",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2582-2",
    "data-name": "Ellipse 2582",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2562-2",
    "data-name": "Ellipse 2562",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 18.748)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2583-2",
    "data-name": "Ellipse 2583",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 76.624)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2584-2",
    "data-name": "Ellipse 2584",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2633-2",
    "data-name": "Ellipse 2633",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2585-2",
    "data-name": "Ellipse 2585",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2623-2",
    "data-name": "Ellipse 2623",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2586-2",
    "data-name": "Ellipse 2586",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2634-2",
    "data-name": "Ellipse 2634",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2587-2",
    "data-name": "Ellipse 2587",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2624-2",
    "data-name": "Ellipse 2624",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2588-2",
    "data-name": "Ellipse 2588",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2678-2",
    "data-name": "Ellipse 2678",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2589-2",
    "data-name": "Ellipse 2589",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2680-2",
    "data-name": "Ellipse 2680",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2590-2",
    "data-name": "Ellipse 2590",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2591-2",
    "data-name": "Ellipse 2591",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2563-2",
    "data-name": "Ellipse 2563",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 28.53)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2592-2",
    "data-name": "Ellipse 2592",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 86.405)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2593-2",
    "data-name": "Ellipse 2593",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2635-2",
    "data-name": "Ellipse 2635",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2594-2",
    "data-name": "Ellipse 2594",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2625-2",
    "data-name": "Ellipse 2625",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2595-2",
    "data-name": "Ellipse 2595",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2636-2",
    "data-name": "Ellipse 2636",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2596-2",
    "data-name": "Ellipse 2596",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2626-2",
    "data-name": "Ellipse 2626",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2597-2",
    "data-name": "Ellipse 2597",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2682-2",
    "data-name": "Ellipse 2682",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2598-2",
    "data-name": "Ellipse 2598",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2684-2",
    "data-name": "Ellipse 2684",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2599-2",
    "data-name": "Ellipse 2599",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2600-2",
    "data-name": "Ellipse 2600",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2564-2",
    "data-name": "Ellipse 2564",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 37.497)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2601-2",
    "data-name": "Ellipse 2601",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 95.372)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2602-2",
    "data-name": "Ellipse 2602",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2637-2",
    "data-name": "Ellipse 2637",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2603-2",
    "data-name": "Ellipse 2603",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2621-2",
    "data-name": "Ellipse 2621",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2604-2",
    "data-name": "Ellipse 2604",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2638-2",
    "data-name": "Ellipse 2638",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2605-2",
    "data-name": "Ellipse 2605",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2627-2",
    "data-name": "Ellipse 2627",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2606-2",
    "data-name": "Ellipse 2606",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2686-2",
    "data-name": "Ellipse 2686",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2607-2",
    "data-name": "Ellipse 2607",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2688-2",
    "data-name": "Ellipse 2688",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2608-2",
    "data-name": "Ellipse 2608",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2609-2",
    "data-name": "Ellipse 2609",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2565-2",
    "data-name": "Ellipse 2565",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 47.278)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2610-2",
    "data-name": "Ellipse 2610",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 105.154)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2611-2",
    "data-name": "Ellipse 2611",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2639-2",
    "data-name": "Ellipse 2639",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2556-2",
    "data-name": "Ellipse 2556",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2653-2",
    "data-name": "Ellipse 2653",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2612-2",
    "data-name": "Ellipse 2612",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2622-2",
    "data-name": "Ellipse 2622",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2613-2",
    "data-name": "Ellipse 2613",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2640-2",
    "data-name": "Ellipse 2640",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2557-2",
    "data-name": "Ellipse 2557",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2654-2",
    "data-name": "Ellipse 2654",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2614-2",
    "data-name": "Ellipse 2614",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2628-2",
    "data-name": "Ellipse 2628",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2615-2",
    "data-name": "Ellipse 2615",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2690-2",
    "data-name": "Ellipse 2690",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2558-2",
    "data-name": "Ellipse 2558",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2691-2",
    "data-name": "Ellipse 2691",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2616-2",
    "data-name": "Ellipse 2616",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(48.093 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2692-2",
    "data-name": "Ellipse 2692",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2617-2",
    "data-name": "Ellipse 2617",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2559-2",
    "data-name": "Ellipse 2559",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2618-2",
    "data-name": "Ellipse 2618",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(57.06 114.935)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2619-2",
    "data-name": "Ellipse 2619",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 57.06)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2560-2",
    "data-name": "Ellipse 2560",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 0)",
    fill: "#121917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2620-2",
    "data-name": "Ellipse 2620",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.842 114.935)",
    fill: "#121917"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14163",
    "data-name": "Group 14163",
    transform: "translate(1079.958 6125.437)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2566-3",
    "data-name": "Ellipse 2566",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 8.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3060",
    "data-name": "Ellipse 3060",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 8.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2643-3",
    "data-name": "Ellipse 2643",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 8.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3061",
    "data-name": "Ellipse 3061",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 8.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2567-3",
    "data-name": "Ellipse 2567",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 66.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3014",
    "data-name": "Ellipse 3014",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 66.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2629-3",
    "data-name": "Ellipse 2629",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 66.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3015",
    "data-name": "Ellipse 3015",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 66.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2568-3",
    "data-name": "Ellipse 2568",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 8.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3062",
    "data-name": "Ellipse 3062",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 8.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2644-3",
    "data-name": "Ellipse 2644",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 8.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3063",
    "data-name": "Ellipse 3063",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 8.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2569-3",
    "data-name": "Ellipse 2569",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 66.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3016",
    "data-name": "Ellipse 3016",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 66.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2630-3",
    "data-name": "Ellipse 2630",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 66.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3017",
    "data-name": "Ellipse 3017",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 66.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2670-3",
    "data-name": "Ellipse 2670",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 8.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3064",
    "data-name": "Ellipse 3064",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 8.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2672-3",
    "data-name": "Ellipse 2672",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 66.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3018",
    "data-name": "Ellipse 3018",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 66.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2575-3",
    "data-name": "Ellipse 2575",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 18.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3019",
    "data-name": "Ellipse 3019",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 18.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2641-3",
    "data-name": "Ellipse 2641",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 18.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3020",
    "data-name": "Ellipse 3020",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 18.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2576-3",
    "data-name": "Ellipse 2576",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 76.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3021",
    "data-name": "Ellipse 3021",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 76.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2631-3",
    "data-name": "Ellipse 2631",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 76.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3022",
    "data-name": "Ellipse 3022",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 76.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2577-3",
    "data-name": "Ellipse 2577",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 18.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3023",
    "data-name": "Ellipse 3023",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 18.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2642-3",
    "data-name": "Ellipse 2642",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 18.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3024",
    "data-name": "Ellipse 3024",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 18.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2578-3",
    "data-name": "Ellipse 2578",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 76.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3025",
    "data-name": "Ellipse 3025",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 76.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2632-3",
    "data-name": "Ellipse 2632",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 76.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3026",
    "data-name": "Ellipse 3026",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 76.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2674-3",
    "data-name": "Ellipse 2674",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 18.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3027",
    "data-name": "Ellipse 3027",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 18.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2676-3",
    "data-name": "Ellipse 2676",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 76.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3028",
    "data-name": "Ellipse 3028",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 76.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2584-3",
    "data-name": "Ellipse 2584",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 28.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3029",
    "data-name": "Ellipse 3029",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 28.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2633-3",
    "data-name": "Ellipse 2633",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 28.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3030",
    "data-name": "Ellipse 3030",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 28.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2585-3",
    "data-name": "Ellipse 2585",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 86.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3031",
    "data-name": "Ellipse 3031",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 86.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2623-3",
    "data-name": "Ellipse 2623",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 86.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3032",
    "data-name": "Ellipse 3032",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 86.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2586-3",
    "data-name": "Ellipse 2586",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 28.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3033",
    "data-name": "Ellipse 3033",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 28.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2634-3",
    "data-name": "Ellipse 2634",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 28.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3034",
    "data-name": "Ellipse 3034",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 28.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2587-3",
    "data-name": "Ellipse 2587",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 86.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3035",
    "data-name": "Ellipse 3035",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 86.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2624-3",
    "data-name": "Ellipse 2624",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 86.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3036",
    "data-name": "Ellipse 3036",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 86.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2678-3",
    "data-name": "Ellipse 2678",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 28.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3037",
    "data-name": "Ellipse 3037",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 28.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2680-3",
    "data-name": "Ellipse 2680",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 86.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3038",
    "data-name": "Ellipse 3038",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 86.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2593-3",
    "data-name": "Ellipse 2593",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 37.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3039",
    "data-name": "Ellipse 3039",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 37.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2635-3",
    "data-name": "Ellipse 2635",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 37.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3040",
    "data-name": "Ellipse 3040",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 37.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2594-3",
    "data-name": "Ellipse 2594",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 95.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3041",
    "data-name": "Ellipse 3041",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 95.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2625-3",
    "data-name": "Ellipse 2625",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 95.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3005",
    "data-name": "Ellipse 3005",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 95.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2595-3",
    "data-name": "Ellipse 2595",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 37.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3042",
    "data-name": "Ellipse 3042",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 37.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2636-3",
    "data-name": "Ellipse 2636",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 37.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3043",
    "data-name": "Ellipse 3043",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 37.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2596-3",
    "data-name": "Ellipse 2596",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 95.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3044",
    "data-name": "Ellipse 3044",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 95.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2626-3",
    "data-name": "Ellipse 2626",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 95.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3006",
    "data-name": "Ellipse 3006",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 95.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2682-3",
    "data-name": "Ellipse 2682",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 37.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3045",
    "data-name": "Ellipse 3045",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 37.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2684-3",
    "data-name": "Ellipse 2684",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 95.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3007",
    "data-name": "Ellipse 3007",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 95.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2602-3",
    "data-name": "Ellipse 2602",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3046",
    "data-name": "Ellipse 3046",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2637-3",
    "data-name": "Ellipse 2637",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3047",
    "data-name": "Ellipse 3047",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2603-3",
    "data-name": "Ellipse 2603",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 105.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3048",
    "data-name": "Ellipse 3048",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 105.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2621-3",
    "data-name": "Ellipse 2621",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 105.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3008",
    "data-name": "Ellipse 3008",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 105.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2604-3",
    "data-name": "Ellipse 2604",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3049",
    "data-name": "Ellipse 3049",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2638-3",
    "data-name": "Ellipse 2638",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3050",
    "data-name": "Ellipse 3050",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2605-3",
    "data-name": "Ellipse 2605",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 105.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3051",
    "data-name": "Ellipse 3051",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 105.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2627-3",
    "data-name": "Ellipse 2627",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 105.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3009",
    "data-name": "Ellipse 3009",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 105.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2686-3",
    "data-name": "Ellipse 2686",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3052",
    "data-name": "Ellipse 3052",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2688-3",
    "data-name": "Ellipse 2688",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 105.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3010",
    "data-name": "Ellipse 3010",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 105.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2611-3",
    "data-name": "Ellipse 2611",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 57.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3053",
    "data-name": "Ellipse 3053",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 57.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2639-3",
    "data-name": "Ellipse 2639",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 57.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3054",
    "data-name": "Ellipse 3054",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 57.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2556-3",
    "data-name": "Ellipse 2556",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3065",
    "data-name": "Ellipse 3065",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2653-3",
    "data-name": "Ellipse 2653",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3066",
    "data-name": "Ellipse 3066",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2612-3",
    "data-name": "Ellipse 2612",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(75.738 114.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3055",
    "data-name": "Ellipse 3055",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(28.53 114.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2622-3",
    "data-name": "Ellipse 2622",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(47.208 114.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3011",
    "data-name": "Ellipse 3011",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(0 114.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2613-3",
    "data-name": "Ellipse 2613",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 57.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3056",
    "data-name": "Ellipse 3056",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 57.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2640-3",
    "data-name": "Ellipse 2640",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 57.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3057",
    "data-name": "Ellipse 3057",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 57.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2557-3",
    "data-name": "Ellipse 2557",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3067",
    "data-name": "Ellipse 3067",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2654-3",
    "data-name": "Ellipse 2654",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3068",
    "data-name": "Ellipse 3068",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2614-3",
    "data-name": "Ellipse 2614",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(85.52 114.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3058",
    "data-name": "Ellipse 3058",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(38.312 114.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2628-3",
    "data-name": "Ellipse 2628",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(56.99 114.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3012",
    "data-name": "Ellipse 3012",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(9.782 114.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2690-3",
    "data-name": "Ellipse 2690",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 57.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3059",
    "data-name": "Ellipse 3059",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 57.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2691-3",
    "data-name": "Ellipse 2691",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3069",
    "data-name": "Ellipse 3069",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2692-3",
    "data-name": "Ellipse 2692",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(66.772 114.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3013",
    "data-name": "Ellipse 3013",
    cx: 1.63,
    cy: 1.63,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(19.563 114.935)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3076",
    "data-name": "Rectangle 3076",
    transform: "translate(1127.012 6112.444)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306.494,
    height: 290.566,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 305.494,
    height: 289.566,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8603",
    "data-name": "Group 8603",
    transform: "translate(1141.173 6130.402)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SWIFT_network_details",
    "data-name": "SWIFT network details",
    transform: "translate(37.744 16.07)",
    fill: "#030303",
    fontSize: 14,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SWIFT network details")), /*#__PURE__*/React.createElement("g", {
    id: "Group_8597",
    "data-name": "Group 8597",
    transform: "translate(0 37.809)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3079",
    "data-name": "Rectangle 3079",
    width: 277.964,
    height: 223.333,
    rx: 6,
    fill: "#dff5ea"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Account_holder_name:_BHA_Trading_Pte._Ltd.",
    "data-name": "Account holder name: BHA Trading Pte. Ltd.",
    transform: "translate(9.736 63.704)",
    fill: "#777",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account holder name:"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Bha Trading Pte. Ltd."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8598",
    "data-name": "Group 8598",
    transform: "translate(3.508 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "globe_2_",
    "data-name": "globe (2)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8334",
    "data-name": "Group 8334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M24.286,14.734,18.933,8.082a.81.81,0,0,0-1.22,0l-2.706,3.363H12.992V8.012a27.2,27.2,0,0,0,4.385-.464l.051-.01a22.228,22.228,0,0,0,2.462-.619.782.782,0,0,0-.471-1.492c-.517.163-1.055.308-1.609.433a12.177,12.177,0,0,0-1.777-3.609A10.593,10.593,0,0,1,22.89,11.94a.783.783,0,0,0,1.565-.042A12.227,12.227,0,1,0,3.805,21.08a.818.818,0,0,0,.1.1l.038.03a12.179,12.179,0,0,0,8.285,3.243c5.441,0,8.954-3.141,9.522-8.447h1.923a.782.782,0,0,0,.609-1.273ZM7.3,11.445a20.512,20.512,0,0,1,.478-3.773,27.583,27.583,0,0,0,3.645.339v3.434Zm5.688-5V2.753a.782.782,0,1,0-1.565,0V6.446A26.056,26.056,0,0,1,8.2,6.153c.9-2.752,2.39-4.588,4.031-4.588,1.558,0,3.094,1.774,4.029,4.588A26.068,26.068,0,0,1,12.992,6.447ZM4.961,20.019A10.656,10.656,0,0,1,8.406,2.275,12.289,12.289,0,0,0,6.649,5.859c-.553-.125-1.09-.269-1.606-.432a.782.782,0,1,0-.471,1.492c.538.17,1.1.32,1.67.452a21.887,21.887,0,0,0-.5,4.074H2.828a.782.782,0,1,0,0,1.565h2.91a22.155,22.155,0,0,0,.506,4.074c-.575.132-1.135.282-1.673.453a.782.782,0,0,0,.236,1.528.8.8,0,0,0,.236-.036A24.214,24.214,0,0,1,12.231,18q.4,0,.789.011a.8.8,0,0,0,.8-.76.782.782,0,0,0-.76-.8q-.413-.011-.832-.012a27.891,27.891,0,0,0-4.45.351A20.512,20.512,0,0,1,7.3,13.01h6.444l-1.387,1.724a.782.782,0,0,0,.61,1.273h1.787a6.579,6.579,0,0,1-3.767,4.434A5.634,5.634,0,0,1,4.961,20.019Zm16.07-5.577a.782.782,0,0,0-.782.74c-.125,2.318-1.157,7.708-8.018,7.708a10.628,10.628,0,0,1-2.68-.341,8.61,8.61,0,0,0,2.111-.693C14.5,20.512,16.4,17.847,16.4,15.224a.783.783,0,0,0-.783-.782h-1.01l3.719-4.621,3.718,4.621Z",
    transform: "translate(-0.005)",
    fill: "#030303"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "globe_2_2",
    "data-name": "globe (2)",
    transform: "translate(9.537 9.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8334-2",
    "data-name": "Group 8334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425-2",
    "data-name": "Path 1425",
    d: "M23.2,16.669a.782.782,0,0,0-.782.74c-.125,2.318-1.157,7.708-8.018,7.708a10.628,10.628,0,0,1-2.68-.341,8.61,8.61,0,0,0,2.111-.693c2.833-1.343,4.736-4.008,4.736-6.631a.783.783,0,0,0-.783-.782h-1.01l3.719-4.621,3.718,4.621Z",
    transform: "translate(-11.716 -12.048)",
    fill: "#12a15a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14284",
    "data-name": "Group 14284",
    transform: "translate(1150.908 6232.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8520",
    "data-name": "Group 8520",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Account_number_IBAN_8850602369575_",
    "data-name": "Account number/IBAN 8850602369575 ",
    transform: "translate(0 13)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account number/IBAN"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "8850602369575 "))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14285",
    "data-name": "Group 14285",
    transform: "translate(1150.908 6290.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8520-2",
    "data-name": "Group 8520",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SWIFT_code_BIC_DBSSSGSG",
    "data-name": "SWIFT code/BIC DBSSSGSG",
    transform: "translate(0 13)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SWIFT code/BIC"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "DBSSSGSG"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14286",
    "data-name": "Group 14286",
    transform: "translate(1261.311 6290.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8519",
    "data-name": "Group 8519",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Bank_name_DBS_Bank_Singapore",
    "data-name": "Bank name DBS Bank, Singapore",
    transform: "translate(9.736 13)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bank name"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "DBS Bank, Singapore"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3194",
    "data-name": "Rectangle 3194",
    width: 0.885,
    height: 31.862,
    transform: "translate(0 4.425)",
    fill: "#d7dfe6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14287",
    "data-name": "Group 14287",
    transform: "translate(1150.908 6341.737)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Bank_address_12_Marina_Boulevard_Singapore_018982",
    "data-name": "Bank address 12 Marina Boulevard, Singapore 018982",
    transform: "translate(0 13)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bank address"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "12 Marina Boulevard, Singapore 018982")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14155",
    "data-name": "Group 14155",
    transform: "translate(1346.506 5937.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3076-2",
    "data-name": "Rectangle 3076",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306.494,
    height: 342.858,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 305.494,
    height: 341.858,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8602",
    "data-name": "Group 8602",
    transform: "translate(14.161 24.454)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Local_channels_details",
    "data-name": "Local channels details",
    transform: "translate(34.802 13.676)",
    fill: "#030303",
    fontSize: 14,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Local channels details")), /*#__PURE__*/React.createElement("text", {
    id: "Account_number_GB92TCCL04140465845215",
    "data-name": "Account number GB92TCCL04140465845215",
    transform: "translate(3.827 43.791)",
    fill: "#777",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account number"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "GB92TCCL04140465845215"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8596",
    "data-name": "Group 8596",
    transform: "translate(0 75.808)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3077",
    "data-name": "Rectangle 3077",
    width: 277.964,
    height: 224.595,
    rx: 6,
    fill: "#fee"
  }), /*#__PURE__*/React.createElement("text", {
    id: "ACH_routing_number_026073150",
    "data-name": "ACH routing number 026073150",
    transform: "translate(12.391 72.09)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ACH routing number"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "026073150"))), /*#__PURE__*/React.createElement("text", {
    id: "Bank_name_Community_Federal_Savings_Bank",
    "data-name": "Bank name Community Federal Savings Bank",
    transform: "translate(12.391 105.998)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "Bank name"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38
  }, "Community Federal Savings Bank"))), /*#__PURE__*/React.createElement("text", {
    id: "Account_holder_address_26_Prinsep_Street_Singapore_188994",
    "data-name": "Account holder address 26 Prinsep Street, Singapore, 188994",
    transform: "translate(12.391 25.182)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account holder address"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "26 Prinsep Street, Singapore, 188994"))), /*#__PURE__*/React.createElement("text", {
    id: "Bank_address_8916_Jamaica_Ave_Woodhaven_NY_11421_USA",
    "data-name": "Bank address 8916 Jamaica Ave, Woodhaven, NY 11421, USA",
    transform: "translate(12.391 155.561)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "Bank address"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 34
  }, "8916 Jamaica Ave, Woodhaven, NY "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 54
  }, "11421, USA")))), /*#__PURE__*/React.createElement("g", {
    id: "local_seo_globe",
    transform: "translate(3.827 -4.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "international_finance_x2C__globe_x2C__money_flow_x2C__money_turnover_4_",
    transform: "translate(0 5.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "global_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8479",
    "data-name": "Group 8479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8476",
    "data-name": "Group 8476",
    transform: "translate(2.745 2.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M21.924,25.852a.414.414,0,0,1-.119-.017,25.807,25.807,0,0,0-14.5,0,.422.422,0,0,1-.237-.81,26.679,26.679,0,0,1,14.979,0,.422.422,0,0,1-.119.827Z",
    transform: "translate(-6.76 -14.272)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M16.5,26.954a.422.422,0,0,1-.238-.77,11.817,11.817,0,0,0,5.19-9.749A11.6,11.6,0,0,0,20.267,11.3a.422.422,0,0,1,.757-.371,12.431,12.431,0,0,1,1.269,5.5A12.662,12.662,0,0,1,16.736,26.88.427.427,0,0,1,16.5,26.954Z",
    transform: "translate(-8.219 -10.565)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M14.348,26.93a.42.42,0,0,1-.238-.073A12.662,12.662,0,0,1,8.553,16.41a12.412,12.412,0,0,1,1.335-5.637.422.422,0,1,1,.753.38A11.588,11.588,0,0,0,9.4,16.41a11.82,11.82,0,0,0,5.19,9.749.422.422,0,0,1-.238.77Z",
    transform: "translate(-7.041 -10.541)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8477",
    "data-name": "Group 8477",
    transform: "translate(10.116 7.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M15.922,27.717A.422.422,0,0,1,15.5,27.3V16.554a.422.422,0,0,1,.843,0V27.3A.421.421,0,0,1,15.922,27.717Z",
    transform: "translate(-15.5 -16.132)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8478",
    "data-name": "Group 8478",
    transform: "translate(1.552 8.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M23.92,17.843H5.768a.422.422,0,0,1,0-.843H23.92a.422.422,0,0,1,0,.843Z",
    transform: "translate(-5.346 -17)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M14.044,26.432A10.538,10.538,0,0,1,6.589,8.439,10.725,10.725,0,0,1,7.9,7.321a.422.422,0,0,1,.493.686A9.7,9.7,0,1,0,20.9,9.036a9.806,9.806,0,0,0-1.115-.959.421.421,0,0,1,.5-.679A10.8,10.8,0,0,1,21.5,8.44a10.537,10.537,0,0,1-7.456,17.992Z",
    transform: "translate(-3.506 -7.242)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8481",
    "data-name": "Group 8481",
    transform: "translate(6.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M3.9,11.67C3.746,11.493,0,7.3,0,4.075A4.154,4.154,0,0,1,4.217,0,4.155,4.155,0,0,1,8.435,4.075c0,3.222-3.745,7.418-3.9,7.6a.426.426,0,0,1-.629,0Zm3.69-7.6A3.307,3.307,0,0,0,4.217.847,3.307,3.307,0,0,0,.844,4.075,3.307,3.307,0,0,1,4.217.847,3.307,3.307,0,0,1,7.593,4.075Z",
    fill: "#12a15a",
    stroke: "#12a15a",
    strokeWidth: 0.8
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionImage1);
export default __webpack_public_path__ + "static/media/solution-image-1.c0166941c64e7b45848c78ab3d544900.svg";
export { ForwardRef as ReactComponent };